export const createPageUrl = (pageName) => `/${pageName.toLowerCase()}`;